import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {
    IVoceCosto
} from "../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceCosto";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiUpdateVoceCosto = (): UseMutationResult<IVoceCosto, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()


    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IVoceCosto> {
        try {
            const response = await put(`/api/company/${company_token}/tannery_production/schede_costo/voci_costo/${pk}/`, data);
            return response.data as IVoceCosto;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IVoceCosto, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetVoceCostoDetail', data.id]});
            await queryClient.invalidateQueries({queryKey: ['useApiGetVociCosto']});
        },
    });
};


export default useApiUpdateVoceCosto;